import { render, staticRenderFns } from "./postComponent.vue?vue&type=template&id=c53af7c0&scoped=true"
import script from "./postComponent.vue?vue&type=script&lang=js"
export * from "./postComponent.vue?vue&type=script&lang=js"
import style0 from "./postComponent.vue?vue&type=style&index=0&id=c53af7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53af7c0",
  null
  
)

export default component.exports